import { render, staticRenderFns } from "./IOptionGroup.vue?vue&type=template&id=abdd4338&"
import script from "./IOptionGroup.vue?vue&type=script&lang=js&"
export * from "./IOptionGroup.vue?vue&type=script&lang=js&"
import style0 from "./IOptionGroup.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QOptionGroup from 'quasar/src/components/option-group/QOptionGroup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QOptionGroup});
